import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const User = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858
                 12 12 12Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    User,
    'user',
);
